module.exports = __webpack_public_path__ + "img/zuijia_21.76870720.png";